module.exports = __webpack_public_path__ + "img/5.ba61bda2.png";